import React from "react";
import { Dialog } from "@/components/journey/journeyDialog";
import { Drawer } from "@/components/journey/journeyDrawer";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { JourneyFooter } from "@/components/journey/layout/journeyFooter";
import { JourneyHeader } from "./layout/journeyHeader";

import { useMemo } from "react";

interface UnitJourneyWrapperProps {
    children: React.ReactNode;
}

export const UnitJourneyWrapper: React.FC<UnitJourneyWrapperProps> = React.memo(({
    children,
}) => {
    const { rentalApp } = useDisplayOptionContext();
    const { isOpen, setIsOpen } =
        useUnitJourneyContext();
    const layout = useMemo(() => {
        switch (rentalApp?.location) {
            case "drawer":
                return (
                    <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
                        <JourneyHeader />
                        {children}
                        <JourneyFooter />
                    </Drawer>
                );
            default:
                return (
                    <Dialog isOpen={isOpen} setIsOpen={setIsOpen}>
                        <JourneyHeader />
                        {children}
                    </Dialog>
                );
        }
    }, [rentalApp?.location, isOpen, setIsOpen, children]);


    return layout;
});
